

export default function Footer(props) {

    return (
        <footer className="footer col-md-9 ms-sm-auto mt-auto py-3 bg-light text-center">
            <span className="text-muted">Copyright © 2021 MHA. All rights reserved.</span>
        </footer>
    )
}